function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M21.112 20.186c1.939-.417 3.717-2.345 3.145-4.734-.448-1.863-2.504-3.686-5.021-3.007-5.492 1.484-3.27 8.853 1.876 7.741zm-1.43-5.67c1.242-.335 2.238.495 2.491 1.403.324 1.164-.529 2.137-1.446 2.372-2.6.667-3.715-3.062-1.044-3.775h-.001zm3.401 6c.365-.204.668-.542 1.22-.514.744.039 2.246 1.254-.396 2.522-1.451.695-1.518.499-2.655.827.196.368 2.278 2.191 2.87 2.753.986.934.147 1.995-.863 1.889-.64-.069-2.654-2.1-3.02-2.519-.82.392-2.268 2.388-3.063 2.51-1.05.162-1.925-.974-.859-1.957l2.837-2.657c-.256-.13-1.046-.234-1.42-.347-4.136-1.262-2.662-3.13-1.478-3.017.427.04.81.375 1.138.554 1.725.938 3.986.919 5.69-.043l-.001-.001z"
});

var SvgOk = function SvgOk(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ok.8e6cb97b.svg";
export { ForwardRef as ReactComponent };